import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-salary-collaborator',
    templateUrl: './salary-collaborator.component.html',
    styleUrls: ['./salary-collaborator.component.scss']
})
export class SalaryCollaboratorComponent implements OnInit {
    @Input() value: number;
    @Output() salary: EventEmitter<any> = new EventEmitter<any>();

    currency = 'R$';
    show = false;

    constructor() {}

    ngOnInit() {
    }
}
